/* eslint-disable default-case */
import React, { Component } from 'react';
import { TextInput, TouchableOpacity, Alert } from 'react-native';
import { withSnackbar } from 'notistack';

import { styles } from './styles';
import Constants from './Constants';
import {
  SIGNIN,
  SIGNINTO,
  EMAIL_REQUIRED,
  INVALID_EMAIL,
  PASSWORD_REQUIRED,
  NEXT,
  GO,
  INTERNET_CHECK,
  LOGIN_SUCCESS,
  LOGOUT,
} from '../../../shared/constants/Constants';
import { Button } from '../../../components/atoms/Button/index';
import * as utility from '../../../shared/services/Utility';

import {
  GREY_COLOR,
  SECONDARY_DARK_COLOR,
  PRIMARY_COLOR,
} from '../../../shared/constants/ColorConstants';
import LoadingModal from '../../../components/atoms/LoadingModal/index';
import Modal from '../../../components/atoms/Modal/container';
import { TutorialSlider } from '../../../components';
import { withRouter } from 'react-router-dom';
// import firebase from '../../../shared/services/firebase';

const { ROUTE_CONSTANTS } = require(`../../../shared/constants/Route`);

class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailId: '',
      password: '',
      emailIdError: '',
      passwordError: '',
      modal: false,
    };
    this.alreadyLogin = false;
    this.fcmToken = 'dummy';
    this.passwordRef = React.createRef();
    this.emailRef = React.createRef();
  }

  componentDidMount() {
    // firebase.messaging().requestPermission()
    //   .then(() => {
    //     firebase.messaging().getToken().then(token => {
    //       if (token) {
    //         this.fcmToken = token;
    //       }
    //     })
    //   })
    //   .catch(function (err) {
    //
    //   });
  }

  showForgot = () => {
    this.props.showForgotModal();
  };

  cleanCredentials() {
    this.setState({
      emailId: '',
      password: '',
    });
  }

  validate = (value, key, allErrors) => {
    switch (key) {
      case 'emailId': {
        if (!value) {
          return (allErrors.emailIdError = EMAIL_REQUIRED);
        }
        if (!utility.validEmail(value)) {
          return (allErrors.emailIdError = INVALID_EMAIL);
        }
        return (allErrors.emailIdError = '');
      }
      case 'password': {
        if (!value) {
          return (allErrors.passwordError = PASSWORD_REQUIRED);
        }
        return (allErrors.passwordError = '');
      }
    }
  };

  validateEmail = () => {
    const { emailId } = this.state;
    if (!emailId) {
      this.setState({ emailIdError: EMAIL_REQUIRED });
      return false;
    }
    if (!utility.validEmail(emailId)) {
      this.setState({ emailIdError: INVALID_EMAIL });
      return false;
    }
    return true;
  };

  onPressLoginBtn() {
    const loginBody = {
      emailId: this.state.emailId.toLowerCase(),
      password: this.state.password,
      deviceToken: this.fcmToken,
      loginCallback: this.cleanCredentials.bind(this),
    };
    const { emailId, password, emailIdError, passwordError } = this.state;

    const allErrors = {
      emailIdError,
      passwordError,
    };
    const arr = [{ emailId }, { password }];
    arr.forEach((obj) =>
      this.validate(Object.values(obj)[0], Object.keys(obj)[0], allErrors),
    );
    this.setState({
      emailIdError: allErrors.emailIdError,
      passwordError: allErrors.passwordError,
    });

    if (allErrors.emailIdError === '' && allErrors.passwordError === '') {
      if (this.props.state.LoginReducer.isNetConnected) {
        this.props.state.LoginReducer.loginStatue = LOGIN_SUCCESS;
        this.props.dispatchLoginRequest(loginBody, (message, type) => {
          this.props.enqueueSnackbar(message, {
            variant: type,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
          if (type === 'success') {
            // setTimeout(() => {
            this.props.history.push(ROUTE_CONSTANTS.ROOT);
            // }, 400);
            this.props.showWelcomeScreen();
          }
        });
      } else {
        this.props.state.LoginReducer.loginStatue = LOGOUT;
        this.alreadyLogin = false;
        Alert.alert(INTERNET_CHECK);
      }
    }
  }

  render() {
    const errorStyle = { color: '#d11919', fontSize: 12, marginTop: '5px' };
    const { emailIdError, passwordError, emailId, password } = this.state;
    return (
      <div className='signup_login_form d-flex'>
        <TutorialSlider/>
        <div className='form-content'>
          <div className='not_member'>
            {'Not a member? '}
            <TouchableOpacity
              onPress={() => this.props.history.push(ROUTE_CONSTANTS.SIGNUP)}
            >
              <span>{' Sign Up'}</span>
            </TouchableOpacity>
          </div>

          <div className='form-fieldset'>
            <h4>{SIGNINTO}</h4>

            <div className='form-contain'>
              <div className='form-fields'>
                <label>{'Email Address'}</label>
                <div className='form-group'>
                  <TextInput
                    style={styles.textInput}
                    value={emailId}
                    placeholder={'E.g. adrian@gmail.com'}
                    placeholderTextColor={GREY_COLOR}
                    keyboardType='email-address'
                    returnKeyType={NEXT}
                    autoCorrect={false}
                    autoFocus={true}
                    autoCapitalize='none'
                    ref={this.emailRef}
                    onChangeText={(text) =>
                      this.setState({ emailId: text, emailIdError: '' })
                    }
                    onSubmitEditing={() => {
                      const res = this.validateEmail();
                      if (res) {
                        this.passwordRef.current.focus();
                      } else {
                        this.emailRef.current.focus();
                      }
                    }}
                    underlineColorAndroid='transparent'
                  />
                  <p style={errorStyle}>{emailIdError}</p>
                </div>
              </div>

              <div className='form-fields'>
                <label>{'Password'}</label>
                <div className='form-group'>
                  <TextInput
                    value={password}
                    style={styles.textInput}
                    placeholder={'***********'}
                    placeholderTextColor='rgb(138, 138, 138)'
                    returnKeyType={GO}
                    secureTextEntry
                    ref={this.passwordRef}
                    autoCorrect={false}
                    onChangeText={(text) =>
                      this.setState({ password: text, passwordError: '' })
                    }
                    underlineColorAndroid='transparent'
                    onSubmitEditing={() => {
                      requestAnimationFrame(() => {
                        if (this.alreadyLogin === false) {
                          this.alreadyLogin = true;
                          this.onPressLoginBtn();
                          setTimeout(() => {
                            this.alreadyLogin = false;
                          }, 5000);
                        }
                      });
                    }}
                  />
                  <p className='error' style={errorStyle}>
                    {passwordError}
                  </p>
                </div>
              </div>

              <Modal
                colorText={PRIMARY_COLOR}
                text={Constants.FORGOT_PASSWORD}
                modalState={(value) => {
                  this.setState({
                    modal: value,
                  });
                }}
              />
              <div className='btn-half row'>
                <div className='col6'>
                  <Button
                    bgColor={SECONDARY_DARK_COLOR}
                    title={SIGNIN}
                    signIn={() => {
                      this.onPressLoginBtn();
                    }}
                    titleColor={'white'}
                  />
                </div>
              </div>
            </div>
          </div>
          {this.state.modal ? null : (
            <LoadingModal isVisible={this.props.loading}/>
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(withSnackbar(LoginScreen));
